import { render, staticRenderFns } from "./Listado.vue?vue&type=template&id=6c62bebf&scoped=true"
import script from "./Listado.vue?vue&type=script&lang=js"
export * from "./Listado.vue?vue&type=script&lang=js"
import style0 from "./Listado.vue?vue&type=style&index=0&id=6c62bebf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c62bebf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c62bebf')) {
      api.createRecord('6c62bebf', component.options)
    } else {
      api.reload('6c62bebf', component.options)
    }
    module.hot.accept("./Listado.vue?vue&type=template&id=6c62bebf&scoped=true", function () {
      api.rerender('6c62bebf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/certificados/oficial-registro/Listado.vue"
export default component.exports